"use client";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AdminHeader from "../../components/organisms/AdminHeader";
import AdminCompanyBanner from "../../components/molecules/AdminCompanyBanner";
import SectionBox from "../../components/layout/SectionBox";
import Footer from "../../components/organisms/Footer";
import AdminCompanyProfileTabs from "../../components/molecules/AdminCompanyProfileTabs";
import AdminProfileContent from "../../components/organisms/AdminProfileContent";
import AdminVerificationContent from "../../components/organisms/AdminVerificationContent";

import { useCompanyProfileStore } from "../../store/useCompanyProfileStore";

export default function AdminCompanyProfile() {
    const [activeTab, setActiveTab] = useState("Profile");

    const location = useLocation();
    const lang = location.pathname.startsWith("/id") ? "id" : "en";
    const profile = useCompanyProfileStore((state) => state.profile);

    const fetchCompanyProfile = useCompanyProfileStore((state) => state.fetchCompanyProfile);

    useEffect(() => {
        fetchCompanyProfile();
    }, [lang, fetchCompanyProfile]);

    return (
        <>
            <AdminHeader />

            <main>
                <div className="container-section mx-auto px-6 pt-6 pb-6">
                    <SectionBox className="mt-24">

                        {!profile ? (
                            <p className="text-gray-500">Loading company data...</p>
                        ) : (
                            <AdminCompanyBanner
                                name={profile.name}
                                industry={profile.industry_id}
                                size={profile.company_size_id}
                                logo={profile.logo}
                                end_date={profile.active_day}
                                start_date={profile.start_date}
                                slot_posting={profile.slot_posting}
                                package_name={profile.package_name}
                                package_id={profile.package_id}
                                website={profile.website}
                                lang={lang}
                                phoneNumber={profile.phone}
                            />
                        )}

                        <AdminCompanyProfileTabs active={activeTab} setActive={setActiveTab} lang={lang} />

                        {activeTab === "Profile" ? (
                            <AdminProfileContent />
                        ) : (
                            <AdminVerificationContent
                                lang={lang} />
                        )}

                    </SectionBox>
                </div>
            </main>

            <Footer />
        </>
    );
}
